import { animated, useTransition } from 'react-spring'
import './Modal.scss'
import ModalContext from './ModalContext'
import { useContext } from 'react'
import classNames from 'classnames'

type ModalBackdropProps = {
  backdropClass?: string
}

const ModalBackdrop: React.FC<ModalBackdropProps> = ({
  backdropClass = '',
}) => {
  const { show } = useContext(ModalContext)

  const backdropTransition = useTransition(show, {
    from: { opacity: 0 },
    enter: { opacity: 0.8 },
    leave: { opacity: 0 },
  })
  return (
    <>
      {backdropTransition((style, item) =>
        item ? (
          <animated.div
            style={style}
            className={classNames('ModalBackdrop', backdropClass)}
          />
        ) : null
      )}
    </>
  )
}

export default ModalBackdrop
